export const strToJson = (str) => {
  try {
    return JSON.parse(str)
  } catch (err) {
    return null
  }
}

// 注册密码,忘记密码满足规则:至少包含字母、数字与符号3种类型中的2种
export function hasValidCharacterTypes (password) {
  var reg = /^[a-zA-Z0-9!@#$%^&*()+=<>?/.,~_-]+$/
  const characterTypes = {
    case: /[a-zA-Z]/,
    number: /\d/,
    symbol: /[!@#$%^&*()+=<>?/.,~_-]/
  }
  let count = 0
  for (const type in characterTypes) {
    if (characterTypes[type].test(password)) {
      count++
    }
  }
  return count >= 2 && reg.test(password)
}



// WEBPACK FOOTER //
// ./src/utils/lib.js